// extracted by mini-css-extract-plugin
module.exports = {"container":"PageLoading-module--container--331wP","loading":"PageLoading-module--loading--1NQ_z"};